/*
 * CHI-27: the return page tells the ticket hooks that an order's tickets are confirmed,
 * so the event page's My Ticket(s) tab shows up without a refresh. It reaches hooks in
 * this tab (window event) and in other open tabs (BroadcastChannel, when available).
 * Carries event slugs only; never a ticket, token or order detail.
 */
const EVENT = "chi:tickets-confirmed";
const CHANNEL = "chi-tickets-confirmed";

/** BroadcastChannel also delivers to other instances in THIS tab; the window event covers those. */
const TAB_ID = Math.random().toString(36).slice(2);

const channel = (): BroadcastChannel | null =>
  typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(CHANNEL);

export function notifyTicketsConfirmed(eventSlugs: string[]): void {
  if (typeof window === "undefined" || eventSlugs.length === 0) return;
  const slugs = Array.from(new Set(eventSlugs));
  window.dispatchEvent(new CustomEvent<string[]>(EVENT, { detail: slugs }));
  const bc = channel();
  if (bc) { bc.postMessage({ from: TAB_ID, slugs }); bc.close(); }
}

export function onTicketsConfirmed(listener: (eventSlugs: string[]) => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const local = (e: Event) => listener((e as CustomEvent<string[]>).detail ?? []);
  window.addEventListener(EVENT, local);
  const bc = channel();
  if (bc) {
    bc.onmessage = (e: MessageEvent) => {
      const data = e.data as { from?: string; slugs?: unknown } | null;
      if (!data || data.from === TAB_ID || !Array.isArray(data.slugs)) return;
      listener(data.slugs.filter((s): s is string => typeof s === "string"));
    };
  }
  return () => { window.removeEventListener(EVENT, local); bc?.close(); };
}
